import { render } from "./courseItem.vue?vue&type=template&id=264e705c"
import script from "./courseItem.vue?vue&type=script&lang=js"
export * from "./courseItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__